module.exports = __webpack_public_path__ + "static/media/logo.cb16d51f.png";